const DB_NAME = 'twin-viewer';
const DB_VERSION = 4;

function open() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (e) => {
      const db = req.result;
      if (!db.objectStoreNames.contains('projects')) {
        db.createObjectStore('projects', { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains('models')) {
        const os = db.createObjectStore('models', { keyPath: 'id' });
        os.createIndex('byProject', 'projectId', { unique: false });
      }
      if (e.oldVersion < 3 && !db.objectStoreNames.contains('routes')) {
        const os = db.createObjectStore('routes', { keyPath: 'id' });
        os.createIndex('byProject', 'projectId', { unique: false });
      }
      if (e.oldVersion < 4 && !db.objectStoreNames.contains('missions')) {
        const os = db.createObjectStore('missions', { keyPath: 'id' });
        os.createIndex('byProject', 'projectId', { unique: false });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function tx(store, mode = 'readonly') {
  return open().then((db) => db.transaction(store, mode).objectStore(store));
}

function reqToPromise(req) {
  return new Promise((resolve, reject) => {
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function getAllProjects() {
  const os = await tx('projects');
  return (await reqToPromise(os.getAll())) || [];
}

export async function getProject(id) {
  const os = await tx('projects');
  return (await reqToPromise(os.get(id))) || null;
}

export async function putProject(project) {
  const os = await tx('projects', 'readwrite');
  await reqToPromise(os.put(project));
  return project;
}

export async function deleteProject(id) {
  const os = await tx('projects', 'readwrite');
  await reqToPromise(os.delete(id));
  const all = await getModelsForProject(id);
  await Promise.all(all.map((m) => deleteModel(m.id)));
}

export async function getModelsForProject(projectId) {
  const os = await tx('models');
  const idx = os.index('byProject');
  return (await reqToPromise(idx.getAll(projectId))) || [];
}

// All models across every project — used by the Library page so a model
// loaded in one project surfaces to others as an importable source.
export async function getAllModels() {
  const os = await tx('models');
  return (await reqToPromise(os.getAll())) || [];
}

export async function getModel(id) {
  const os = await tx('models');
  return (await reqToPromise(os.get(id))) || null;
}

export async function putModel(model) {
  const os = await tx('models', 'readwrite');
  await reqToPromise(os.put(model));
  return model;
}

export async function deleteModel(id) {
  const os = await tx('models', 'readwrite');
  await reqToPromise(os.delete(id));
}

export async function getRoutesForProject(projectId) {
  const os = await tx('routes');
  const idx = os.index('byProject');
  return (await reqToPromise(idx.getAll(projectId))) || [];
}

export async function putRoute(route) {
  const os = await tx('routes', 'readwrite');
  await reqToPromise(os.put(route));
  return route;
}

export async function deleteRoute(id) {
  const os = await tx('routes', 'readwrite');
  await reqToPromise(os.delete(id));
}

export async function getMissionsForProject(projectId) {
  const os = await tx('missions');
  const idx = os.index('byProject');
  return (await reqToPromise(idx.getAll(projectId))) || [];
}

export async function putMission(mission) {
  const os = await tx('missions', 'readwrite');
  await reqToPromise(os.put(mission));
  return mission;
}

export async function deleteMission(id) {
  const os = await tx('missions', 'readwrite');
  await reqToPromise(os.delete(id));
}
